/**
 * Featured Banner Block
 *
 * @class rlFeaturedBanner
 * @memberOf jQuery.fn
 */

(function($) {
    $.fn.rlFeaturedBanner = function() {
        $('.featurebannerblock .featurebanner-wrapper').matchHeight();

       function bannerBlockPolyfills() {
            $(".featurebanner-container").each(function() {
                const thirdCtaButton = $(this).find('.fbb-text-btn').children('.cta'),
                    bannerImageSml = $(this).find('.blockpadding').children('.image').children('img.mobile'),
                  bannerImageLrg = $(this).find('.blockpadding').children('.image').children('img.desktop');

                if ($(this).css('background-image') == 'none') {
                   $(this).addClass('noimage');
                }
                else {
                   $(this).removeClass('noimage');
                }
               
                //FULL widthlayouts
                const FeatureBannerMobileFWImage = $(this).children('.fullwidthimage-mobile-image-container');
                if (FeatureBannerMobileFWImage.css('background-image') == 'none') {
                  FeatureBannerMobileFWImage.addClass('no-image-on-mobile');
                } else {
                  FeatureBannerMobileFWImage.removeClass('no-image-on-mobile');
                }

                //left & right layouts
                const FeatureBannerImage = $(this).children('.featurebanner-image');
                if (FeatureBannerImage.css('background-image') == 'none') {
                    FeatureBannerImage.addClass('no-image-on-mobile');
                } else {
                    FeatureBannerImage.removeClass('no-image-on-mobile');
                }

                //magnify glass & support logo checker scripts
                if (FeatureBannerImage.hasClass('col-lg-4')) {
                    $(this).find('.ctawrapper').addClass('direction-row');
                }
                if ($(this).find('.supportlogo').length > 0 && $(this).find('.buttons').length == 0) {
                    $(this).find('.supportlogo').addClass('nomargin');
                }

                //third Cta Button copy length polyfill
                if (thirdCtaButton.length > 0 && thirdCtaButton.height() >= 42) {
                    thirdCtaButton.parent().addClass('multiline');
                } else {
                    thirdCtaButton.parent().removeClass('multiline');
                }

                //Promo Block Details Banner Image Aria Hidden label checker
                if (bannerImageSml.is(':hidden')) {
                    bannerImageSml.attr('aria-hidden', 'true');
                    bannerImageLrg.attr('aria-hidden', 'false');
                } else {
                    bannerImageSml.attr('aria-hidden', 'false');
                    bannerImageLrg.attr('aria-hidden', 'true');
                }
            });
        }

        function navBottomPosition() {
            const navBlock = $('.featurebannernavigationblock .featurebanner-navigation');
            navBlock.find('.fb-nav-item').matchHeight({ remove: true });

            if ($('#header .logo-lg').css('display') === 'block') {

                const navBarPos = navBlock.innerHeight(),
                    oneLine = 68, //is one line
                    twoLine = 86, //is two lines
                    bottomPosition = (navBarPos / 2) - 2;

                if (navBarPos >= oneLine && navBarPos < twoLine) { //is one line
                    navBlock.css('bottom', '-33px');
                }
                else if (navBarPos > twoLine) { //is more than (default) 2 lines
                    navBlock.css('bottom', -bottomPosition);
                }
                else {
                    navBlock.removeAttr('style'); //remove inline style as default bottom position (2 lines) is set in sass.
                }

            }

            else {
                navBlock.removeAttr('style'); //is mobile-tablet (hint: different layout mode)
                navBlock.find('.fb-nav-item').matchHeight({ byRow: false });
            }
            
        }


        bannerBlockPolyfills();
        navBottomPosition();
        checkForLiteEmptyBackground();

        //timeout needed to ensure images have loaded
        setTimeout(function () {
          MagnifyingGlassImgHeight();
          setBackGroundSize();
        }, 150);

        $(window).on('resize-end', function () {
            navBottomPosition();
            bannerBlockPolyfills();
            MagnifyingGlassImgHeight();
        });

        //Magnifying Glass Specific functions

        function setBackGroundSize() {
          $(".featurebanner-container .magnifyglass").each(function () {
            //find out the width and height of the css background image

              var imageUrl = $(this).find('.logo').children('span').css('background-image').match(/^url\(["']?(.+?)["']?\)$/);
              var dfd = new $.Deferred();

              if (imageUrl) {
                var image = new Image();
                image.src = imageUrl[1];
              }
              else {
                dfd.reject();
              }

              if (image.height > image.width) {
                $(this).find('.logo').children('span').addClass('portrait');
              }
          });
        }

        function MagnifyingGlassImgHeight() {
          $(".featurebanner-container .magnifyglass").each(function () {
            var elspan = $(this).find('.logo').children('span'),
                elwidth = elspan.innerWidth();

            elspan.css('height', elwidth).css('opacity', '1');
          });
        }  

       //FBB Lite Specific Functions

       function checkForLiteEmptyBackground() {
          const currentURL = document.URL,
             positionURL = currentURL.lastIndexOf('/') + 1,
             cleanURL = currentURL.slice(0, positionURL),
             selectorImage = $('.featurebannerblocklite .featurebanner-image');

          

          selectorImage.each(function () {
             if ($(this).css('background-image') === 'url("' + cleanURL + '")' || $(this).css('background-image') === 'url("")') {
                $(this).parents('.featurebanner-split').addClass('no-background-image');
                $(this).next('.featurebanner-background').removeClass('col-md-6').addClass('col-md-10');
                $(this).removeClass('col-md-6').addClass('col-md-2');
             }
          });
       }

    };
}(jQuery));
